const EVENT_MESSAGE_NAME = 'event-message';
const CRITICAL_BACKUP_REDIRECT_TYPE = 'CRITICAL_BACKUP_REDIRECT';

/**
 * Lit l'ordre de redirection de secours dans un message du canal temps réel de la session.
 * Renvoie l'URL cible, ou null si le message n'en porte pas.
 */
export function readCriticalBackupRedirectUrl(
  messageName: string | undefined,
  data: unknown,
): string | null {
  if (messageName !== EVENT_MESSAGE_NAME) return null;
  if (!data || typeof data !== 'object') return null;

  const payload = data as { type?: unknown; criticalBackupUrl?: unknown };
  if (payload.type !== CRITICAL_BACKUP_REDIRECT_TYPE) return null;

  const url = typeof payload.criticalBackupUrl === 'string' ? payload.criticalBackupUrl.trim() : '';
  if (!url) return null;

  // Le message déclenche un `location.replace` : une adresse `javascript:` ou `data:` s'exécuterait
  // dans la page du spectateur.
  try {
    const protocol = new URL(url).protocol;
    return protocol === 'http:' || protocol === 'https:' ? url : null;
  } catch {
    return null;
  }
}
